import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import util from "../util/util";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";
import Pagination from "../pagination/pagination";

const jQuery = window.jQuery;

export default function ChangeLogList(props) {
  // change log to display (will be populated by an Ajax call);
  const [log, setLog] = useState([]);
  // page of rule results;
  const [page, setPage] = useState(1);
  // number of pages to display in the pagination links;
  const [pageCount, setPageCount] = useState(0);
  // pass to sort and pagination links to maintain search state;
  const [queryString, setQueryString] = useState(null);
  // list sort value;
  const [sort, setSort] = useState(`-date_created`);

  useEffect(() => {
    const pageNo = Number(_.get(props, `params.page`, 1));
    const sortBy = _.get(props, `location.query.sort`, `-date_created`);

    const getChangeLog = () => {
      // get the change log content;
      util
        .getStationChangeLog({
          page: pageNo,
          sort: sortBy
        })
        .then(data => {
          setTimeout(() => {
            setPage(pageNo);
            setPageCount(Math.ceil(data.count / util.changeLogResultsPerPage));
            setQueryString(_.get(props, `location.search`, null));
            setSort(sortBy);
            setLog(data.results.length ? data.results : false);
          }, util.delayList);
        });
    };

    getChangeLog();
  }, [props]);

  // three options for display (loading, no results, results);
  const renderRows = (logs = false) => {
    if (logs.length === 0) {
      return (
        <tr>
          <td colSpan="5">
            <LoadingIndicatorText />
          </td>
        </tr>
      );
    } else if (logs === false) {
      return (
        <tr>
          <td>
            <strong>0</strong>
          </td>
          <td colSpan="4">{util.zeroLogsMessage}</td>
        </tr>
      );
    } else {
      return logs.map((log, index) => {
        return index < util.changeLogResultsPerPage ? (
          <tr key={index}>
            <td>
              <strong>
                {util.returnLineNumber(
                  page,
                  util.changeLogResultsPerPage,
                  index
                )}
              </strong>
            </td>
            <td>
              <Link
                to={util.returnChangeLogDetailUrl(`user`, log.revision.user.id)}
              >
                {log.revision.user.email || log.revision.user.name}
              </Link>
            </td>
            <td>
              <Link
                to={util.returnChangeLogDetailUrl(
                  log.content_type,
                  log.object_id
                )}
              >
                {log.object_name}
              </Link>
            </td>
            <td>{log.description}</td>
            <td>
              {moment(log.revision.date_created).format(
                util.dateFormatHumanLong
              )}
            </td>
          </tr>
        ) : null;
      });
    }
  };

  // display table header sort links;
  const renderSortLink = (sortValue, sortDisplay) => {
    const className = util.returnSortClass(sortValue, sort);
    const newSortValue = util.returnSortValue(sortValue, sort);
    const queryStringObject = queryString
      ? jQuery.deparam(queryString.replace(`?`, ``))
      : {};

    // add the new sort value to the querystring object;
    queryStringObject.sort = newSortValue;

    return (
      <Link
        to={`${util.returnChangeLogListUrl()}?${jQuery.param(
          queryStringObject
        )}`}
        className={className}
      >
        {sortDisplay}
        <i className="fa fa-sort-desc" aria-hidden="true"></i>
        <i className="fa fa-sort-asc" aria-hidden="true"></i>
      </Link>
    );
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__title">Change Log</h4>
        </div>
      </div>

      <hr />

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `1%` }}></col>
            <col style={{ width: `20%` }}></col>
            <col style={{ width: `30%` }}></col>
            <col style={{ width: `30%` }}></col>
            <col style={{ width: `19%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>User</th>
              <th>Object</th>
              <th>Change</th>
              <th>{renderSortLink(`-date_created`, `Date`)}</th>
            </tr>
          </thead>
          <tbody>{renderRows(log)}</tbody>
        </table>
      </div>

      <Pagination
        currentPage={page}
        pageCount={pageCount}
        path="changelog"
        queryString={queryString}
      />
    </div>
  );
}

ChangeLogList.propTypes = {
  params: PropTypes.object
};
